/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCountry,
    IdentityMelcoModelsCountryFromJSON,
    IdentityMelcoModelsCountryFromJSONTyped,
    IdentityMelcoModelsCountryToJSON,
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsCountry
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsCountry {
    /**
     * 
     * @type {Array<IdentityMelcoModelsCountry>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountry
     */
    list: Array<IdentityMelcoModelsCountry>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountry
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountry
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsCountry {
    return IdentityMelcoModelsGenericList1MelcoModelsCountryFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsCountryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsCountryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


